export enum CommunicationType {
    EMAIL = 'Email',
    MOBILE = 'Mobile',
}

export interface validateVerifyOtp {
  communicationType: string,
  email: string,
  otp: string
}
  
  
  export interface ResetPwdRequest {
    email: string,
    appName?: string
  }


  export enum PasswordType {
    PASSWORD = 'Password',
    CONFIRM_PASSWORD = 'ConfirmPassword',
  }
  
  export interface ResetPasswordRequest {
    email: string,
    password: string,
    confirmPassword: string,
    appName?: string
  }
  
  export interface ResetPasswordResponse {
    status: boolean,
    error?: string,
    message?: string
  }
  
  export interface ResetPwdResponse {
    status: boolean,
    error?: string,
    message?: string
  }
  
  export interface GenerateOtpRequest {
    communicationType: string,
    receiver: string,
    verificationType: string
  }
  
  export interface GenerateOtpResponse {
    status: boolean,
    error?: string,
    message?: string
  }

  export interface EmailMobileUniqueResponse{
    status: any
    communitcationType: string,
    receiver: string,
  }
  
  export interface VerifyOtpRequest {
    communicationType: string,
    receiver: string,
    verificationType: string,
    otp: string,
    appName?: string
  }
  
  export interface VerifyOtpResponse {
    status: boolean,
    error?: string,
    message?: string
  }